<template>
  <div class="landing">
    <header class="header">

      <section class="menu clearfix">
        <div class="logo">
          <img src="../assets/lp/logo.png" alt="ikude">
        </div>


        <div class="logo_mobile">
          <div class="logo_mobile_inner">
            <img src="../assets/lp/logo.png" alt="Ikude">
          </div>
        </div>

        <div class="drawer-toggle" role="button" @click="$store.dispatch('toggleSidebar')">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>


        <div class="controller">
          <nav>
            <ul class="lp-nav">
              <li><a href="/">TOP</a></li>
              <li><a href="/#usecase">活用方法</a></li>
              <li><a href="/#function">機能</a></li>
              <li><a href="/#contact">お問合せ</a></li>
            </ul>
          </nav>
        </div>
      </section>

    </header>

    <!-- Drawer Menu -->
    <div class="sidenav-container">

      <div v-if="toggleSidebar" class="backdrop" @click="$store.dispatch('toggleSidebar')"></div>

      <transition name="slide-side">
        <div v-if="toggleSidebar" class="sidenav">
          <div>
            <ul class="nav-list">
              <li class="nav-item"><a @click="$store.dispatch('toggleSidebar')" href="/">TOP</a></li>
              <li class="nav-item"><a @click="$store.dispatch('toggleSidebar')" href="/#usecase">活用方法</a></li>
              <li class="nav-item"><a @click="$store.dispatch('toggleSidebar')" href="/#function-mobile">機能</a></li>
              <li class="nav-item"><a @click="$store.dispatch('toggleSidebar')" href="/#contact">お問合せ</a></li>
            </ul>
          </div>
        </div>
      </transition>
    </div>


    <section class="content">
      <div class="content_grid">
        <section id="content_description">
          <h1 class="site-title">「これから行くで、そろそろ着くな」</h1>
          <h2 class="site-subtitle">が分かる位置情報サービス</h2>

          <button class="start_button" @click="goHome">登録済の方はこちら</button>

        </section>
        <section>

        </section>
      </div>


    </section>

    <section class="service" id="service">
      <div class="service_grid">
        <div id="service_screenshots">
          <div>
            <img class="service-image-top" src="../assets/lp/service1.png" alt="service1">
          </div>
          <div>
            <img class="service-image-bottom" src="../assets/lp/service2.png" alt="service2">
          </div>
        </div>
        <div class="service_description">
          <h3 class="service-heading">SERVICE</h3>
          <h4 class="service-heading-sub">ikudeとは</h4>
          <p class="service-text">ドライバーの現在位置をチーム全員で把握し、<br>
            到着を待つお客様に、いつでも場所を<br>
            通知することのできるアプリです。</p>
          <p class="service-text-sub">お客様はURLから気軽に確認、場所が分かって安心</p>
          <img class="service-process" src="../assets/lp/process.png" alt="process">
        </div>
      </div>
    </section>
    <section id="usecase" class="usecase">
      <h3 class="heading">USE CASE</h3>
      <h4 class="heading-sub">サービスの活用事例</h4>
      <p class="service-text">ikudeが提供する位置情報サービスは、<br>
        さまざまなシーンでご活用いただけます。</p>
      <div class="usecase-wrapper">
        <div class="usecase-box">
          <div class="usecase-left">
            <img class="usecase-image" src="../assets/lp/delivery.png" alt="delivery"></div>
          <div class="usecase-right">
            <p class="usecase-title">配達の通知</p>
            <p class="usecase-text">
              正確な現在位置を伝えて不在率減少。<br>
              配達ルートの見直しも可能です。</p>
            <a class="usecase_button"
               href="https://firebasestorage.googleapis.com/v0/b/foober-ced85.appspot.com/o/reflet_delivery.pdf?alt=media&token=68628990-b389-4960-bd38-cef5ff5f4a1f">資料を見る</a>
          </div>
        </div>
        <div class="usecase-box">
          <div class="usecase-left">
            <img class="usecase-image" src="../assets/lp/transfer.png" alt="transfer"></div>
          <div class="usecase-right">
            <p class="usecase-title">送迎管理</p>
            <p class="usecase-text">
              送迎車の位置の共有で事故率低下。<br>
              利用者への連絡の効率化にも。</p>
            <a class="usecase_button"
               href="https://firebasestorage.googleapis.com/v0/b/foober-ced85.appspot.com/o/reflet_transfer.pdf?alt=media&token=433f04cb-b5a5-4b27-b7b5-56714f805009">資料を見る</a>
          </div>
        </div>
        <div class="usecase-box">
          <div class="usecase-left">
            <img class="usecase-image" src="../assets/lp/salescar.png" alt="salescar"></div>
          <div class="usecase-right">
            <p class="usecase-title">車両管理</p>
            <p class="usecase-text">
              営業車がどこを走っているのかチェック。<br>
              営業効率アップに貢献します。</p>
            <a class="usecase_button"
               href="https://firebasestorage.googleapis.com/v0/b/foober-ced85.appspot.com/o/reflet_delivery.pdf?alt=media&token=68628990-b389-4960-bd38-cef5ff5f4a1f">資料を見る</a>
          </div>
        </div>
      </div>
    </section>

    <section id="function" class="function">
      <h3 class="heading">FUNCTION</h3>
      <h4 class="heading-sub">ikudeで出来ること</h4>
      <div class="function-wrapper">
        <div class="function-left-img">
          <img class="function-image" src="../assets/lp/function_1.png" alt="function1"></div>
        <div class="function-right-text">
          <p class="function-title">ドライバーの位置の確認</p>
          <p class="function-text">
            チームでお使いのPC、タブレットや<br>
            お客様のスマートフォンから
          </p></div>
      </div>
      <div class="function-wrapper">
        <div class="function-left-text">
          <p class="function-title">位置情報の共有</p>
          <p class="function-text">
            ボタン2つでかんたん共有<br>お客様はURLから位置確認ができて手軽</p></div>
        <div class="function-right-img">
          <img class="function-image" src="../assets/lp/function_2.png" alt="function2">
        </div>
      </div>
      <div class="function-wrapper">
        <div class="function-left-img">
          <img class="function-image" src="../assets/lp/function_3.png" alt="function3"></div>
        <div class="function-right-text">
          <p class="function-title">目的地までの経路作成</p>
          <p class="function-text">
            目的地と現在地を随時確認
          </p></div>
      </div>
      <div class="function-wrapper">
        <div class="function-left-text">
          <p class="function-title">目的地リストの管理</p>
          <p class="function-text">
            ドライバーに複数目的地がある場合、<br>
            リスト形式で管理ができます。
          </p>
        </div>
        <div class="function-right-img">
          <img class="function-image" src="../assets/lp/function_4.png" alt="function4">
        </div>
      </div>
    </section>


    <section id="function-mobile" class="function-mobile">
      <h3 class="heading">FUNCTION</h3>
      <h4 class="function-heading-sub">ikudeで出来ること</h4>
      <div class="function-mobile-wrapper">

        <div>
          <p class="function-mobile-title">ドライバーの位置の確認</p>
          <p class="function-mobile-text">
            チームでお使いのPC、タブレットや<br>
            お客様のスマートフォンから
          </p></div>

        <div>
          <img class="function-mobile-image" src="../assets/lp/function_1.png" alt="function1"></div>
      </div>
      <div class="function-mobile-wrapper">
        <div>
          <p class="function-mobile-title">位置情報の共有</p>
          <p class="function-mobile-text">
            ボタン2つでかんたん共有<br>お客様はURLから位置確認ができて手軽</p></div>
        <div>
          <img class="function-mobile-image" src="../assets/lp/function_2.png" alt="function2">
        </div>
      </div>
      <div class="function-mobile-wrapper">

        <div>
          <p class="function-mobile-title">目的地までの経路作成</p>
          <p class="function-mobile-text">
            目的地と現在地を随時確認
          </p></div>

        <div>
          <img class="function-mobile-image" src="../assets/lp/function_3.png" alt="function3"></div>
      </div>
      <div class="function-mobile-wrapper">
        <div>
          <p class="function-mobile-title">目的地リストの管理</p>
          <p class="function-mobile-text">
            ドライバーに複数目的地がある場合、<br>
            リスト形式で管理ができます。
          </p>
        </div>
        <div>
          <img class="function-mobile-image" src="../assets/lp/function_4.png" alt="function4">
        </div>
      </div>
    </section>


    <section class="step" id="step">
      <h3 class="heading2">INTRODUCTION STEP</h3>
      <h4 class="heading-sub2">導入の流れ</h4>
      <div class="step-wrapper">
        <div class="step-box">
          <img class="step-image" src="../assets/lp/intro1.png" alt="Step1">
          <p class="step-text">
            アカウント発行
          </p>
        </div>
        <div class="step-box">
          <img class="step-image" src="../assets/lp/intro2.png" alt="Step2">
          <p class="step-text">
            ikude.jpにログイン<br>
            ドライバーを追加
          </p>
        </div>
        <div class="step-box">
          <img class="step-image" src="../assets/lp/intro3.png" alt="Step3">
          <p class="step-text">
            アプリをお使いの<br>
            スマホにインストール
          </p>
        </div>
      </div>
    </section>
    <!--価格
        <section class="price" id="price">
          <h3 class="heading2">PRICE</h3>
          <h4 class="heading-sub2">サービス利用料金</h4>
          <p class="price-text">普段お使いのスマートフォンのみで導入可能！<br>
            初期費用0円、月額制で試しやすい</p>
          <img class="price-image" src="../assets/lp/price.png" alt="price">
        </section>
    -->
    <section class="contact" id="contact">
      <h3 class="heading">CONTACT</h3>
      <h4 class="heading-sub">お問合せ</h4>
      <h1 class="sales">sales@ikude.jp</h1>
      <p class="caption">お気軽にお問い合わせください</p>
    </section>

    <footer class="footer">
      <p class="copy">copyright © Goldrush Computing Inc. All Rights Reserved.</p>

    </footer>
  </div>
</template>

<script>
  import {Slide} from 'vue-burger-menu'

  export default {
    name: 'LandingPage',


    components: {
      Slide
    },

    data() {
      return {}
    },

    computed: {

      toggleSidebar() {
        return this.$store.getters['toggleSidebar']
      }

    },

    methods: {


      goTopOfLP() {
        this.$router.push('/')
      },

      goUserCaseOfLP() {
        this.$router.push('/#usecase')
      },

      goFunctionOfLP() {
        this.$router.push('/#function')
      },

      goContactOfLP() {
        this.$router.push('/#contact')
      },
      goHome() {
        this.$router.push({name: 'Home'})
      },

    },

  }
</script>


<!-- グローバルを上書きするスタイル -->
<style>

  /* モバイル */
  .mobile_menu {
    color: #F3F3F3;

  }

  .mobileHeader {
    padding: 0 0 0 0;
  }

  .slide_lp .bm-burger-button {
    width: 20px;
    height: 20px;
    top: 18px;
    right: 0;
    margin: 0 0 0 0;
    padding: 0 0 0 0;
    cursor: pointer;
    outline: none;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  }

  .slide_lp .line-style {
    position: absolute;
    height: 15%;
    left: 0;
    right: 0;
  }

  .slide_lp .bm-burger-bars {
    background-color: #5c5c5c;
  }



  .slide_lp .bm-overlay {
    background: rgba(0, 0, 0, 0.0);
  }

  .slide_lp .bm-item-list {
    width: 300px;
    margin-left: 7%;
    font-size: 16px;
  }


</style>

<style scoped>

  *, *::before, *::after {
    box-sizing: border-box;
  }

  .landing {

    color: #707070;
    text-align: center;
    font-size: 20px;
    font-family: "Yu Gothic", "Meiryo", sans-serif;
  }

  ::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }


  header {
    width: 100%;
    height: 50px;
    margin: 0 auto;
    padding: 0;
    background-color: #FFFFFF;
    /*border-bottom: 1px solid #D6B000;*/
  }


  .logo {
    float: left;
    padding: 0 0 0 0;
  }

  .logo img {
    position: absolute;
    margin: -8px 0 0 0;
    width: 128px;
    height: auto;
  }



  /* モバイル */
  .logo_mobile {
    display: table;
    width: 100px;
    height: 81%;
    margin-left: auto;
    margin-right: auto;
  }

  .logo_mobile_inner {
    display: table-cell;
    width: 100px;
    height: 100%;
    vertical-align: middle;
  }

  .logo_mobile img{
    width: 100px;
    height: auto;
  }


  /* ナビゲーションエリア */
  .controller {
    float: right;
    margin-top: 14px;
    margin-bottom: 10px;
  }


  /* ナビゲーション */
  .lp-nav {
    float: right;
    margin: 0 20px 0 0;
  }

  .lp-nav li {
    float: left;
    margin: 0 30px 0 0;
    font-size: 18px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: bold;
    list-style: none;
  }

  .lp-nav li a {
    color: #707070;
  }

  .lp-nav li a:hover {
    border-bottom: 2px solid #ffffff;
    padding-bottom: 3px;
    text-decoration: none;
    color: #D2FF00;
  }


  .content {
    padding: 200px 0 260px 100px;

    background: #D2FF00 url('../assets/lp/bg2.png') no-repeat fixed left bottom;
    background-position: center center;
    background-size: cover;

  }

  a {
    text-decoration: none;
    color: #707070;
  }

  .start_button {
    background-color: #707070;
    color: #fff;
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    margin-top: 20px;
    padding: 18px 16px 18px 16px;
    border-radius: 16px;
    border-color: transparent;
    outline:none;
  }

  .start_button:hover {
    text-decoration: none;
    background-color: #fff;
    color: #D2FF00;
  }

  .usecase {
    padding: 60px 85px;
    background-color: #D2FF00;
    color: #707070;
  }

  .usecase-wrapper {
    width: 90%;
    margin: 50px auto 0;

  }


  .usecase-image {
    width: 100%;
    vertical-align: center;
    padding: 30px;
  }

  .usecase-box {
    display: grid;
    grid-template-columns: 1.5fr 2fr;
    background-color: #fff;
    border-radius: 80px;
    padding: 20px;
    margin: 30px 60px 30px 30px;
  }

  .usecase-text {
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 800;
    text-align: left;
    margin-left: 20px;
  }

  .usecase-title {
    font-size: 40px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 900;
    text-align: left;
    margin-left: 20px;

  }

  .usecase_button {
    background-color: #F09999;
    color: #fff;
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    margin: 15px 10px 15px 100px;
    padding: 10px 25px 10px 25px;
    border-radius: 16px;
    border-color: transparent;
  }

  .usecase_button:hover {
    text-decoration: none;
    background-color: #fff;
    color: #F09999;
    border-radius: 16px;
    border: 2px solid #F09999;

  }

  .site-title {
    width: 100%;
    font-size: 28px;
  }

  .site-subtitle {
    margin-top: 0;
    font-size: 22px;
  }

  .service {
    padding: 60px 115px;
    background-color: #fff;
    color: #707070;
  }

  .service-process {
    padding: 40px 0;
    width: 100%;
  }

  .left {
    float: left;
    width: 400px;
  }

  .right {
    float: right;
    width: 500px;
  }

  .clearfix::after {
    content: '';
    display: block;
    clear: both;
  }

  .service-image-top {
    width: 80%;
    margin: 0 40px 0 auto;
    padding: 10px;
  }

  .service-image-bottom {
    margin: 0 40px 0 auto;
    width: 80%;
    padding: 10px;
  }


  .service-heading {
    padding: 20px 0 0;
    margin: 0;
    font-size: 40px;
    font-family: "OCR A", monospace;
    color: #D2FF00;
  }

  .service-heading-sub {
    padding: 0;
    margin: 0;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    color: #D2FF00

  }

  .heading {
    margin: 0;
    font-size: 40px;
    font-family: "OCR A", monospace
  }

  .heading-sub {
    margin: 10px 0 0 0;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
  }


  .heading2 {
    margin: 0;
    font-size: 40px;
    font-family: "OCR A", "Montserrat", monospace;
    color: #D2FF00;
  }

  .heading-sub2 {
    margin: 10px 0 0 0;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    color: #D2FF00;
  }

  .servide-text-sub {
    margin: 0;
    padding: 0;
    font-size: 14px;
  }

  .function {
    display: block;
    padding: 60px 115px;
    background-color: #F1F1F1;
    color: #707070;
  }

  .function-mobile {
    display: none;
  }

  .function-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 80%;
    padding: 10px;
    margin: 0 auto;

  }

  /*https://stackoverflow.com/a/12326152/1709287*/
  .function-left-text {
    margin-top: 30px;
    margin-left: auto;
    margin-right: 0;
  }

  .function-right-text {
    margin-top: 30px;
    margin-right: auto;
    margin-left: 20px;
  }


  .function-left-img {
    margin-left: auto;
    margin-right: 0;
  }

  .function-right-img {
    margin-right: auto;
    margin-left: 0;
  }


  .function-image {
    width: 80%;
  }

  .function-title {
    font-size: 20px;
    background-color: #D2FF00;
    width: 290px;
    padding: 10px 25px 10px 25px;
    border-radius: 16px;
    margin-top: 60px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 900;
    vertical-align: center;
  }

  .function-text {
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 800;
    vertical-align: center;
    margin-bottom: 30px;
    text-align: left;
    padding: 20px 25px 10px 25px;
  }


  .service-text {
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 800;
    padding: 20px 0 0;

  }


  .step {
    padding: 60px 115px 30px;
    background-color: #fff;
    color: #707070

  }

  .step-wrapper {
    width: 80%;
    display: table;
    margin: 50px auto 0;
    table-layout: fixed;
  }

  .step-box {
    display: table-cell;
  }

  .step-image {
    width: 80%;
  }

  .step-text {
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 900;
    padding: 20px;
  }

  .price {
    padding: 60px 115px;
    background-color: #fff;
    color: #707070;
  }

  .price-image {
    width: 80%;
    margin-top: 30px;
  }

  .price-text {
    font-size: 20px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    font-weight: 900;
  }

  .contact {
    padding: 60px 115px;
    background-color: #D2FF00;
    color: #707070;
    margin-bottom: 0;
  }

  .sales {
    font-size: 50px;
    padding: 0;
    margin-top: 20px;
  }

  .caption {
    margin: 10px 0 0 0;
    font-size: 14px;
    font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    color: #707070;
  }

  .footer {
    margin-top: 0;
    background-color: #F1F1F1;
    color: #707070
  }

  .copy {
    padding: 0;
    font-size: 14px;
  }


  /* CONTENT グリッドレイアウト */
  .content_grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr minmax(180px, 1fr);
  }

  /* service グリッドレイアウト */
  .service_grid {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr minmax(200px, 1fr);
  }



  /* SideNav Layout */
  .sidenav-container {
    height: 100%;
    width: 100%;
  }

  .sidenav {
    height: 100%;
    width: 50%;
    background-color: #F0F0F0;
    z-index: 10000;
    position: fixed;
    top: 0;
    left: 50%;
    box-sizing: border-box;
    padding: 30px;
  }

  .backdrop {
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
  }

  .slide-side-enter-active,
  .slide-side-leave-active {
    transition: all 0.3s ease-out;
  }
  .slide-side-enter,
  .slide-side-leave-to {
    transform: translateX(200%);
  }

  .nav-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .nav-item {
    margin: 27px 0;
    color: #5C5C5C;
    font-size: 18px;
    font-weight: normal;
    text-align: left;
  }

  .nav-item a {
    text-decoration: none;
    color: #5C5C5C;
    font-size: 18px;
    font-weight: normal;
  }

  .nav-item a:hover,
  .nav-item a:active{
    color: #b4b4b4;
  }

  .drawer-toggle .bar {
    width: 90%;
    height: 3px;
    background-color: #5C5C5C;
  }

  .drawer-toggle {
    display: flex;
    position:absolute;
    right:15px;
    top:15px;

    justify-self: end;
    flex-direction: column;
    justify-content: space-around;
    height: 28px;
    width: 30px;
    cursor: pointer;

    -webkit-tap-highlight-color:  rgba(255, 255, 255, 0);
  }


  /*スマホ対応 */
  @media (max-width: 1024px) {


    header {
      width: 100%;
      height: 50px;
      margin: 0 auto;
      padding: 0;
      background-color: #fff;
      /*border-bottom: 1px solid #D6B000;*/

    }

    .logo {
      display: none;
    }

    .logo_mobile{
      display: table;
    }

    .content {
      padding: 290px 0 25px 0;
      background: #D2FF00 url('../assets/lp/bg_mobile.png') no-repeat fixed;
      background-position: 50% 0%;
      background-size: contain;
      text-align: center;
      margin: 0 auto;
    }

    .content_grid {
      display: block;
    }

    .site-title {
      text-shadow: 1px 1px 0 #D2FF00, -1px -1px 0 #D2FF00,
      -1px 1px 0 #D2FF00, 1px -1px 0 #D2FF00,
      0px 1px 0 #D2FF00, 0 -1px 0 #D2FF00,
      -1px 0 0 #D2FF00, 1px 0 0 #D2FF00;
      font-size: 18px;
      margin: 0 auto;
      padding: 0 auto;
    }

    .site-subtitle {
      text-shadow: 1px 1px 0 #D2FF00, -1px -1px 0 #D2FF00,
      -1px 1px 0 #D2FF00, 1px -1px 0 #D2FF00,
      0px 1px 0 #D2FF00, 0 -1px 0 #D2FF00,
      -1px 0 0 #D2FF00, 1px 0 0 #D2FF00;
      margin: 0 auto;
      padding: 0 auto;
      font-size: 14px;
    }

    .start_button {
      background-color: #707070;
      color: #fff;
      font-size: 15px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      margin: 0px 10px 15px 10px;
      padding: 8px 10px 8px 10px;
      border-radius: 16px;
      border-color: transparent;
    }

    .usecase {
      padding: 20px 25px;
      background-color: #D2FF00;
      color: #707070;
    }

    .usecase-wrapper {
      width: 90%;
      margin: 20px auto 0;

    }


    .usecase-image {
      width: 100%;
      vertical-align: center;
      padding: 30px 30px 10px 30px;
    }

    .usecase-box {
      display: table;
      background-color: #fff;
      border-radius: 40px;
      padding: 0 20px 10px 20px;
      margin: 0 0 15px 0;
    }

    .usecase-text {
      font-size: 12px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      font-weight: 900;
      text-align: center;
    }

    .usecase-title {
      font-size: 18px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      font-weight: 900;
      margin-bottom: 5px;
      text-align: center;

    }

    .usecase_button {
      background-color: #F09999;
      color: #fff;
      font-weight: 900;
      font-size: 15px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      margin: 15px 10px 25px 10px;
      padding: 10px 25px 10px 25px;
      border-radius: 16px;
      border-color: transparent;
    }

    .usecase_button:hover {
      text-decoration: none;
      background-color: #fff;
      color: #F09999;
      border-radius: 16px;
      border: 2px solid #F09999;
    }

    .service-text {
      font-size: 14px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      font-weight: 900;
      padding: 20px 0 10px 0;
    }

    .service {
      padding: 20px 25px;
      background-color: #fff;
      color: #707070;
    }

    .service-process {
      padding: 0;
      width: 85%;
    }

    .left {

      width: 768px;
    }

    .right {

      width: 768px;
    }

    .clearfix::after {
      content: '';
      display: block;
      clear: both;
    }

    .service-image-top {
      width: 80%;
      margin: 0;
      padding: 10px;
    }

    .service-image-bottom {
      margin: 0;
      width: 80%;
      padding: 10px;
    }


    .service-heading {
      margin: 0;
      font-size: 25px;
      font-family: "OCR A", monospace;
      color: #D2FF00;
    }

    .service-heading-sub {
      padding: 0;
      margin: 0;
      font-size: 13px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      color: #D2FF00

    }

    .heading {
      margin: 0;
      font-size: 25px;
      font-family: "OCR A", monospace
    }

    .heading-sub {
      margin: 3px 0 0 0;
      font-size: 13px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    }


    .heading2 {
      margin: 0;
      font-size: 25px;
      font-family: "OCR A", monospace;
      color: #D2FF00;
    }

    .heading-sub2 {
      margin: 10px 0 0 0;
      font-size: 13px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      color: #D2FF00;
    }


    .service_grid {
      display: block;

    }

    .service-text-sub {
      margin-bottom: 20px;
      padding: 0;
      font-size: 12px;
    }

    .function {
      display: none;
    }

    .function-mobile {
      padding: 20px 25px;
      background-color: #F1F1F1;
      color: #707070;
      display: block;
    }


    .function-heading-sub {
      margin: 3px 0 40px 0;
      font-size: 13px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
    }

    .function-mobile-wrapper {
      display: block;
      width: 100%;
      padding: 0;
    }

    .function-mobile-image {
      width: 100%;
      margin-top: 0;
      margin-bottom: 40px;
    }


    .function-mobile-title {
      font-size: 18px;
      background-color: #D2FF00;
      width: 250px;
      padding: 8px 15px 8px 15px;
      border-radius: 16px;
      margin: 20px auto 0 auto;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      font-weight: 900;
    }

    .function-mobile-text {
      font-size: 14px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      font-weight: 800;
      vertical-align: center;
      margin-top: 10px;
      width: 100%;
      text-align: center;
      padding: 10px 15px 10px 15px;
      line-height: 25px;
      margin-bottom: 10px;
    }


    .step {
      padding: 20px 25px;
      background-color: #fff;
      color: #707070

    }

    .step-wrapper,
    .step-box {
      display: block;
    }

    .step-image {
      width: 80%;
    }

    .step-text {
      font-size: 14px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      font-weight: 900;
      padding: 20px;
      margin: 0;
      line-height: 25px;
    }

    .contact {
      padding: 10px 15px 40px 15px;
      background-color: #D2FF00;
      color: #707070;
      margin-bottom: 0;
    }

    .sales {
      font-size: 35px;
      padding: 0;
      margin-top: 20px;
    }

    .footer {
      margin: 0;
      background-color: #F1F1F1;
      color: #707070
    }

    .copy {
      padding: 0;
      margin: 0;
      font-size: 10px;
    }

    .caption {
      margin: 10px 0 0 0;
      font-size: 12px;
      font-family: 游ゴシック体, 'Yu Gothic', YuGothic, メイリオ, Meiryo, sans-serif;
      color: #707070;
    }


    .controller {
      display: none
    }


    .drawer-toggle {
      display: flex;
    }


  }


  @media (min-width: 1025px) {

    .logo_mobile{
      display: none
    }

    .controller {
      display: block
    }


    .drawer-toggle {
      display: none;
    }
  }


</style>



// WEBPACK FOOTER //
// src/pages/LandingPage.vue